import { api } from '@/lib/axios';
import { type Notification, type CreateNotificationParams, type UpdateNotificationParams } from '../types/notification.types';

export const createNotification = async (params: CreateNotificationParams): Promise<Notification> => {
  try {
    const { data } = await api.post<Notification>('/api/notifications', params);
    return data;
  } catch (error) {
    console.error('Error al crear la notificación:', error);
    throw new Error('Error al crear la notificación');
  }
};

export const getNotifications = async (): Promise<Notification[]> => {
  try {
    const { data } = await api.get<Notification[]>('/api/notifications');
    return data;
  } catch (error) {
    console.error('Error al obtener las notificaciones:', error);
    throw new Error('Error al obtener las notificaciones');
  }
};

export const getNotificationById = async (id: string): Promise<Notification> => {
  try {
    const { data } = await api.get<Notification>(`/api/notifications/${id}`);
    return data;
  } catch (error) {
    console.error('Error al obtener la notificación:', error);
    throw new Error('Error al obtener la notificación');
  }
};

export const updateNotification = async (id: string, params: UpdateNotificationParams): Promise<Notification> => {
  try {
    const { data } = await api.put<Notification>(`/api/notifications/${id}`, params);
    return data;
  } catch (error) {
    console.error('Error al actualizar la notificación:', error);
    throw new Error('Error al actualizar la notificación');
  }
};

export const deleteNotification = async (id: string): Promise<void> => {
  try {
    await api.delete(`/api/notifications/${id}`);
  } catch (error) {
    console.error('Error al eliminar la notificación:', error);
    throw new Error('Error al eliminar la notificación');
  }
};

export interface NotificationSearchParams {
  notificationStatusId?: number[];
  targetUserRole?: string | null;
  originUserRole?: string | null;
  userId?: number;
}

export const searchNotifications = async (params: NotificationSearchParams): Promise<Notification[]> => {
  try {
    const { data } = await api.post<Notification[]>('/api/notifications/search', params);
    return data;
  } catch (error) {
    console.error('Error al buscar notificaciones:', error);
    throw new Error('Error al buscar notificaciones');
  }
}; 